var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import { createSelector } from 'reselect';
import styled from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import MuiPopper from '@material-ui/core/Popper';
import TextField from '@material-ui/core/TextField';
import { paletteDividerSelector, getColorBackgroundSelector, getColorPrimarySelector, getColorTextSelector, getColorGreySelector, getSpacingSelector, getElevationLayerSelector } from '@signal/theme/selectors';
import { clearfix } from '@signal/theme/mixins';
import IconBack from '../Icons/Back';
import IconForward from '../Icons/Forward';
import IconCalendar from '../Icons/Calendar';
import Typography from '../Typography';
var iconProps = {
  size: 18
};
export var Popper = styled(MuiPopper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: ", ";\n"])), getElevationLayerSelector('tooltip'));
export var NavPrevIcon = styled(IconBack).attrs(iconProps)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), getColorPrimarySelector());
export var NavNextIcon = NavPrevIcon.withComponent(IconForward);
export var ButtonCalendarIcon = styled(IconCalendar).attrs(iconProps)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-right: ", "px;\n"])), getSpacingSelector(2));
export var InputCalendarIcon = styled(IconCalendar).attrs(iconProps)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), getColorPrimarySelector());
export var DateInput = styled(TextField).attrs(function () {
  return {
    margin: 'dense',
    variant: 'outlined',
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(InputCalendarIcon, null))
    },
    InputLabelProps: {
      shrink: true
    },
    readOnly: true
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  caret-color: transparent;\n\n  input {\n    cursor: pointer;\n  }\n"])));
export var ButtonTypography = styled(Typography).attrs(function () {
  return {
    variant: 'body4',
    component: 'span'
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), createSelector(function (props) {
  return props.disabled;
}, getColorGreySelector(400), function (isDisabled, colorGrey) {
  return isDisabled && "\n      && {\n        color: ".concat(colorGrey, ";\n      }");
}));
export var DatePickerWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n\n  .DayPicker__horizontal, .CalendarMonthGrid, .CalendarMonth {\n    background-color: ", ";\n  }\n\n  .CalendarDay__default {\n    border: 0 !important;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  .CalendarDay__default:hover {\n    background: #b3e5fc;\n  }\n\n  .CalendarDay__blocked_out_of_range {\n    background-color: ", " !important;\n    color: ", " !important;\n  }\n\n  /* Will edit selected date or the endpoints of a range of dates */\n  .CalendarDay__selected:hover,\n  .CalendarDay__selected_span:hover,\n  .CalendarDay__selected {\n    background: #b3e5fc;\n    color: inherit !important;\n  }\n\n  .CalendarDay__hovered_span:hover,\n  .CalendarDay__hovered_span,\n  .CalendarDay__selected_span {\n    background: rgba(179, 229, 252, 0.5);\n    color: inherit !important;\n  }\n\n  .CalendarDay__highlighted_calendar {\n    background: #ffe0b2;\n  }\n\n  /* Navigation button styles */\n  .DayPickerNavigation_button__horizontal {\n    position: absolute;\n    top: 0;\n    padding: 18px 13px;\n  }\n\n  .DayPickerNavigation_button__horizontal:first-of-type {\n    left: 9px;\n  }\n\n  .DayPickerNavigation_button__horizontal:last-of-type:not(:first-of-type) {\n    right: 9px;\n  }\n\n  /* Month caption styles */\n  .CalendarMonth_caption {\n    padding-top: 15px;\n    padding-bottom: 56px;\n    border-bottom: solid 1px ", ";\n  }\n\n  /* Weekday names header */\n  .DayPicker_weekHeader {\n    top: 69px;\n  }\n"])), clearfix, getColorBackgroundSelector('paper'), getColorTextSelector(), getColorBackgroundSelector('paper'), getColorBackgroundSelector(), getColorTextSelector('disabled'), paletteDividerSelector);
export var PresetWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 9px;\n  display: grid;\n  grid-column-gap: 12px;\n  grid-template-columns: 1fr 1fr 1fr;\n"])));
export var InputWrapper = styled(PresetWrapper)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  grid-template-columns: 1fr 1fr;\n  margin-bottom: 0;\n"])));